import { create } from "zustand";

const DEFAULT_DATA = {
  sectionType: "no_text",
  alignment: "left",
  title: "<p>Title</p>",
  titleColor: "#172b4d",
  titleBold: false,
  titleSize: 32,
  overline: "<p>OVERLINE</p>",
  overlineColor: "#0052CC",
  overlineSize: 18,
  text: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>",
  textColor: "#172b4d",
  textSize: 22,
  lineColor: "#0052CC",
  lineWidth: 10,
  lineWeight: 3,
  iconSize: 40,
  iconColor: "#0052CC",
  titleIcon: "bootstrap/CloudsFill",
  emojiEnabled: false,
  selectedTab: "layout",
  colorsByColorScheme: {
    dark: {
      overlineColor: "#0052CC",
      titleColor: "#FFFFFF",
      textColor: "#FFFFFF",
      lineColor: "#0052CC",
      iconColor: "#0052CC",
    },
    light: {
      overlineColor: "#0052CC",
      titleColor: "#172b4d",
      textColor: "#172b4d",
      lineColor: "#0052CC",
      iconColor: "#0052CC",
    },
  },
  activeColorsByColorScheme: "light",
  emoji: {},
  layout: { overline: true, title: true, text: true, line: true, icon: true },
};

export const useTitleTextStore = create((set, get) => ({
  data: DEFAULT_DATA,
  setData: (value, isUndo = false, isRedo = false) => {
    const currentData = get().data;
    const newData = { ...currentData, ...value };

    if (!isUndo && !isRedo) {
      get().pushToHistory(newData);
    }

    set(() => ({
      data: newData,
    }));
  },
  getData: () => get().data,

  position: 0,
  updatePosition: (value) => {
    set(() => ({
      position: value,
    }));
  },

  history: [],
  pushToHistory: (value) => {
    const newHistory = [...get().history, value];

    set(() => ({
      history: newHistory,
      position: newHistory.length - 1,
    }));
  },

  undo: () => {
    const { history, position, setData } = get();
    setData(
      {
        ...history[position - 1],
      },
      true,
      false
    );
    set({ position: position - 1 });
  },
  redo: () => {
    const { history, position, setData } = get();
    setData(
      {
        ...history[position + 1],
      },
      false,
      true
    );
    set({ position: position + 1 });
  },

  canUndo: () => {
    const { position } = get();
    return position > 0;
  },
  canRedo: () => {
    const { history, position } = get();
    return position < history.length - 1;
  },

  resetStore: () => {
    set({
      data: DEFAULT_DATA,
      position: 0,
      history: [],
    });
  },
}));
